module.exports = __webpack_public_path__ + "media/icons/icon-close-86ae4c33.svg";